import { Link } from 'react-router-dom';

const footerLinks = {
  快速导航: [
    { href: '/', label: '首页' },
    { href: '/category/all', label: '全部视频' },
    { href: '/category/planting', label: '种植全流程' },
    { href: '/category/display', label: '成品展示' },
    { href: '/about', label: '关于我们' },
  ],
  视频分类: [
    { href: '/category/cultivation', label: '人工培育' },
    { href: '/category/making', label: '制作技巧' },
    { href: '/category/harvest', label: '采收技术' },
  ],
  学习资源: [
    { href: '/category/planting', label: '新手入门指南' },
    { href: '/article/a2', label: '夏季管理要点' },
    { href: '/article/a4', label: '智能菇房方案' },
    { href: '/article/a8', label: '病害识别防治' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2.5 mb-4">
              <div className="w-9 h-9 flex items-center justify-center">
                <i className="ri-seedling-line text-2xl text-accent-500"></i>
              </div>
              <span className="font-heading text-lg text-background-50">
                蘑菇成品人视频
              </span>
            </Link>
            <p className="text-sm text-foreground-400 leading-relaxed">
              汇聚最全面的蘑菇成品人视频资源，涵盖蘑菇种植全流程、成品展示及人工操作技巧，帮助用户快速掌握蘑菇从培育到成品的完整视频教程。
            </p>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="font-heading text-background-100 text-base mb-4">
                {title}
              </h4>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link.href}>
                    <Link
                      to={link.href}
                      className="text-sm text-foreground-400 hover:text-accent-400 transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-foreground-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 蘑菇成品人视频精选合集. 版权所有.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-accent-400 transition-colors" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-xs text-foreground-500 hover:text-accent-400 transition-colors" rel="nofollow">
              使用条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}